import { UserTenantRole } from '@tabeeb/enums'

export const tenantsRolesToAllowEditPatient = [
  UserTenantRole.SystemAdmin,
  UserTenantRole.BillingAdmin,
  UserTenantRole.TenantAdmin,
]
